(() => {
  "use strict";

  if (window.RPPartsFinderData) {
    return;
  }

  const CAMBER_NOTE =
    "Important Note: This is a CAMBER axle beam, slightly bent to help support the trailer load.";

  const COLLECTIONS = {
    axles: "/collections/see-all-axle-assemblies",
    bearings: "/collections/bearings-races-caps-seals",
    diyAxle: "/collections/do-it-yourself-kits",
    hydraulicBrakes: "/collections/hydraulic-brake-parts",
    drumsPlates: "/collections/drums-backing-plates",
    suspension: "/collections/leaf-springs-u-bolts-suspension",
    heavyRunning: "/collections/heavy-duty-running-gear-8k",
    hubs: "/collections/hubs",
    axleParts: "/collections/other-axle-parts",
    spindles: "/collections/spindles-spindle-repair-kits",
    wheels: "/collections/tires-wheels-hub-caps",
    grease: "/collections/greases-and-oils",
    marineRunning: "/collections/ufp-boat-trailer-running-gear",
    airBrakes: "/collections/air-brakes",

    couplers: "/collections/couplers",
    jacks: "/collections/jack-jack-parts",
    ramps: "/collections/ramp-holders-levers-hinges",
    safetyChains: "/collections/safety-chains",
    specialtyScrews: "/collections/speciality-screws",
    documentHolders: "/collections/document-holders",
    hitchBalls: "/collections/hitch-balls",
    pintle: "/collections/pintle-products",
    ballMounts: "/collections/receiver-ball-mounts",
    receivers: "/collections/truck-receiver-hitches",
    weightDistribution: "/collections/weight-distribution-sway-control",

    breakaway: "/collections/battery-break-aways",
    brakeControls: "/collections/brake-controllers-harnesses",
    converters: "/collections/converters-chargers",

    lighting: "/collections/trailer-rv-lighting",
    lightMounting: "/collections/accessories-mounting",
    led: "/collections/see-all-led-lights",
    incandescent: "/collections/see-all-incandescent-light",
    lightTesters: "/collections/light-testers",
    plugs: "/collections/trailer-plugs-cords-adapters",
    trailerWiring: "/collections/trailer-wiring-kits",
    truckWiring: "/collections/truck-plug-wiring-kits",

    hatches: "/collections/electrical-water-sewer-hatches",
    freshWater: "/collections/fresh-water-tanks-accessories",
    gasStruts: "/collections/gas-struts-accessories",
    doorHardware: "/collections/handles-door-hold-backs",
    trimsSeals: "/collections/trims-seals",
    vents: "/collections/vents",
    wireLoom: "/collections/wire-loom",

    tieDowns: "/collections/d-rings-tie-downs",
    locks: "/collections/locks-security",
    spareMounts: "/collections/spare-tire-mounts",
    wheelChocks: "/collections/wheel-chocks",
    winches: "/collections/winches",
    strapsChains: "/collections/straps-binders-chains"
  };

  const OPTIONS = {
    axleCapacity: [
      "Up to 2,000 lb",
      "2,200 lb",
      "3,500 lb",
      "4,400 lb",
      "5,200 lb",
      "6,000 lb",
      "7,000 lb",
      "8,000 lb",
      "9,000–10,000 lb",
      "12,000 lb",
      "14,000–16,000 lb",
      "Other / unknown"
    ],

    boltPattern: [
      "4 on 4",
      "5 on 4.5",
      "5 on 5",
      "5 on 5.5",
      "6 on 5.5",
      "8 on 6.5",
      "10 lug",
      "Other / unknown"
    ],

    brakeSize: [
      "7 x 1-1/4",
      "10 x 2-1/4",
      "12 x 2",
      "12-1/4 x 3-3/8",
      "12-1/4 x 4",
      "Other / unknown"
    ],

    wheelSize: [
      "8 inch",
      "10 inch",
      "12 inch",
      "13 inch",
      "14 inch",
      "15 inch",
      "16 inch",
      "17.5 inch",
      "Other / unknown"
    ],

    plugType: [
      "4-way flat",
      "5-way flat",
      "6-way round",
      "7-way blade",
      "7-way round pin",
      "2-pole",
      "Other / unknown"
    ],

    ballSize: [
      "1-7/8 inch",
      "2 inch",
      "2-5/16 inch",
      "3 inch",
      "Other / unknown"
    ],

    receiverSize: [
      "1-1/4 inch",
      "2 inch",
      "2-1/2 inch",
      "3 inch",
      "Other / unknown"
    ],

    springWidth: [
      "1-3/4 inch",
      "2 inch",
      "2-1/2 inch",
      "3 inch",
      "Other / unknown"
    ],

    side: [
      "Left / driver side",
      "Right / passenger side",
      "Pair / both sides",
      "Orientation unknown"
    ],

    axleCount: [
      "Single axle",
      "Tandem axle",
      "Triple axle",
      "Other / unknown"
    ],

    quantity: [
      "One component",
      "Pair",
      "One axle set",
      "Tandem-axle set",
      "Triple-axle set",
      "Other / unknown"
    ],

    yesNoUnknown: [
      "Yes",
      "No",
      "Not sure"
    ]
  };

  const qSelect = (
    key,
    label,
    options,
    help = "",
    config = {}
  ) => ({
    key,
    label,
    type: "select",
    options,
    help,
    required: config.required !== false,
    showWhen: config.showWhen || null
  });

  const qText = (
    key,
    label,
    placeholder,
    help = "",
    config = {}
  ) => ({
    key,
    label,
    type: config.type || "text",
    placeholder,
    help,
    inputmode: config.inputmode || "text",
    required: config.required !== false,
    showWhen: config.showWhen || null
  });

  const qNote = (
    text,
    config = {}
  ) => ({
    key: config.key || "",
    label: "",
    type: "note",
    text,
    required: false,
    showWhen: config.showWhen || null
  });

  const task = (
    id,
    label,
    collection,
    searchBase,
    fitment,
    questions = [],
    extra = {}
  ) => ({
    id,
    label,
    collection,
    searchBase,
    fitment,
    questions,
    aliases: extra.aliases || [],
    uses: extra.uses || [],
    resultType:
      extra.resultType ||
      (collection ? "collection" : "search"),
    resultTitle: extra.resultTitle || label,
    verificationNote: extra.verificationNote || "",
    camber: Boolean(extra.camber),
    trailerPriority: extra.trailerPriority || []
  });

  const shared = {
    partNumber: qText(
      "part_number",
      "Enter the number exactly as stamped or printed",
      "Example: L44649, 10-19, casting, model, or R&P SKU",
      "A similar number does not prove compatibility."
    ),

    capacity: qSelect(
      "capacity",
      "Axle or component capacity",
      OPTIONS.axleCapacity,
      "Use the rating shown on the axle tag, component label, or manufacturer documentation."
    ),

    boltPattern: qSelect(
      "bolt_pattern",
      "Wheel bolt pattern",
      OPTIONS.boltPattern,
      "Lug count alone may not identify the bolt circle."
    ),

    brakeSize: qSelect(
      "brake_size",
      "Brake diameter and shoe width",
      OPTIONS.brakeSize,
      "Measure the inside drum diameter and brake-shoe width."
    ),

    wheelSize: qSelect(
      "wheel_size",
      "Wheel or tire diameter",
      OPTIONS.wheelSize
    ),

    quantity: qSelect(
      "quantity",
      "Quantity or axle coverage",
      OPTIONS.quantity,
      "Confirm whether the product is sold individually, as a pair, or as an axle set."
    )
  };

  const trailerTypes = [
    {
      id: "utility",
      label: "Utility / Landscape Trailer"
    },
    {
      id: "enclosed",
      label: "Enclosed / Cargo Trailer"
    },
    {
      id: "equipment",
      label: "Equipment / Car Hauler"
    },
    {
      id: "boat",
      label: "Boat / Marine Trailer"
    },
    {
      id: "horse",
      label: "Horse / Livestock Trailer"
    },
    {
      id: "rv",
      label: "RV / Camper"
    },
    {
      id: "dump",
      label: "Dump Trailer"
    },
    {
      id: "flatbed",
      label: "Flatbed / Gooseneck"
    },
    {
      id: "tow-vehicle",
      label: "Tow Vehicle / Hitch Setup"
    },
    {
      id: "unknown",
      label: "Other / Not Sure"
    }
  ];

  const areas = [
    {
      id: "axles",
      label: "Axles, Hubs, Bearings & Running Gear"
    },
    {
      id: "brakes",
      label: "Brakes, Actuators, Controllers & Breakaway"
    },
    {
      id: "suspension",
      label: "Leaf Springs, Equalizers, Hangers & U-Bolts"
    },
    {
      id: "towing",
      label: "Couplers, Hitch Parts, Pintle & Safety Chains"
    },
    {
      id: "jacks",
      label: "Trailer Jacks, Landing Gear & Stabilizers"
    },
    {
      id: "lighting",
      label: "Trailer Lights, Wiring, Plugs & Electrical"
    },
    {
      id: "doors",
      label: "Doors, Ramps, Gas Struts & Body Hardware"
    },
    {
      id: "cargo",
      label: "Cargo Control, E-Track, Winches & Security"
    },
    {
      id: "wheels",
      label: "Tires, Wheels, Lug Hardware & Hub Caps"
    },
    {
      id: "rv",
      label: "RV Hatches, Tanks, Vents & Electrical"
    },
    {
      id: "maintenance",
      label: "Grease, Fasteners & General Service Parts"
    },
    {
      id: "unknown",
      label: "Not Sure What System It Belongs To"
    }
  ];

  const methods = [
    {
      id: "task",
      label: "Choose the part or repair task"
    },
    {
      id: "spec",
      label: "Identify it by specifications or measurements"
    },
    {
      id: "number",
      label: "Search a SKU, manufacturer number, bearing, seal, or casting"
    },
    {
      id: "problem",
      label: "Describe the problem or job you are doing"
    },
    {
      id: "help",
      label: "I have photos, measurements, or I am not sure"
    }
  ];

  const tasks = {
    axles: [
      task(
        "complete-axle",
        "Complete axle assembly",
        COLLECTIONS.axles,
        "complete trailer axle assembly",
        "Confirm axle type, capacity, hub face, spring center or bracket measurement, brakes, bolt pattern, spindle configuration, camber, and mounting orientation.",
        [
          qSelect(
            "axle_type",
            "Axle construction",
            [
              "Leaf-spring beam axle",
              "Torsion axle",
              "Drop axle",
              "V-bend marine axle",
              "Not sure"
            ]
          ),

          shared.capacity,

          qSelect(
            "brakes",
            "Hub and brake configuration",
            [
              "Idler / no brakes",
              "Electric drum brakes",
              "Hydraulic drum brakes",
              "Hydraulic disc brakes",
              "Beam only",
              "Not sure"
            ]
          ),

          qText(
            "hub_face",
            "Hub-face measurement",
            "Example: 89 inches",
            "Measure wheel-mounting face to wheel-mounting face.",
            {
              required: false
            }
          ),

          qText(
            "mounting_center",
            "Spring-center or torsion-bracket measurement",
            "Example: 74 inches",
            "Identify the exact measurement convention.",
            {
              required: false
            }
          ),

          shared.boltPattern
        ],
        {
          aliases: [
            "trailer axle",
            "replacement axle",
            "axle assembly"
          ],
          trailerPriority: [
            "utility",
            "equipment",
            "dump",
            "flatbed"
          ]
        }
      ),

      task(
        "axle-beam",
        "Axle beam only",
        COLLECTIONS.axles,
        "trailer axle beam",
        "Confirm capacity, hub face, spring center, tube construction, spindle style, camber, drop, spring-seat orientation, and brake-flange configuration.",
        [
          shared.capacity,

          qSelect(
            "beam_style",
            "Beam style",
            [
              "Straight beam",
              "Drop beam",
              "Camber beam",
              "Straight / non-camber beam",
              "V-bend marine beam",
              "Not sure"
            ]
          ),

          qText(
            "hub_face",
            "Hub-face measurement",
            "Example: 95 inches",
            "Measure between the wheel-mounting faces.",
            {
              required: false
            }
          ),

          qText(
            "spring_center",
            "Spring-center measurement",
            "Example: 80 inches",
            "Measure center-to-center of the spring seats.",
            {
              required: false
            }
          ),

          qSelect(
            "flange",
            "Brake-flange requirement",
            [
              "No brake flange",
              "4-bolt flange",
              "5-bolt flange",
              "Pattern unknown",
              "Not sure"
            ]
          )
        ],
        {
          aliases: [
            "bare axle",
            "beam axle",
            "cambered axle"
          ],
          camber: true
        }
      ),

      task(
        "torsion-axle",
        "Torsion axle / Torflex-style assembly",
        COLLECTIONS.axles,
        "torsion trailer axle",
        "Confirm capacity, hub face, bracket dimensions, bracket profile, start angle, arm direction, mounting orientation, brakes, and bolt pattern.",
        [
          shared.capacity,

          qText(
            "hub_face",
            "Hub-face measurement",
            "Example: 85.5 inches",
            "",
            {
              required: false
            }
          ),

          qText(
            "bracket_measure",
            "Torsion bracket measurement",
            "Example: 72.5 inches outside bracket",
            "State whether it is inside-to-inside or outside-to-outside.",
            {
              required: false
            }
          ),

          qSelect(
            "start_angle",
            "Start angle",
            [
              "45° up",
              "22.5° up",
              "10° up",
              "0°",
              "10° down",
              "22.5° down",
              "45° down",
              "Other / unknown"
            ]
          ),

          qSelect(
            "arm_direction",
            "Arm direction",
            [
              "Trailing arm",
              "Leading arm",
              "Not sure"
            ]
          ),

          qSelect(
            "brakes",
            "Brake configuration",
            [
              "Idler",
              "Electric drum",
              "Hydraulic drum",
              "Hydraulic disc",
              "Not sure"
            ]
          )
        ]
      ),

      task(
        "idler-hub",
        "Idler hub",
        COLLECTIONS.hubs,
        "trailer idler hub",
        "Confirm inner and outer bearings, seal, bolt pattern, wheel pilot, stud size, hub length, spindle profile, and rated application.",
        [
          shared.capacity,
          shared.boltPattern,

          qText(
            "inner_bearing",
            "Inner bearing number",
            "Example: L68149",
            "",
            {
              required: false
            }
          ),

          qText(
            "outer_bearing",
            "Outer bearing number",
            "Example: L44649",
            "",
            {
              required: false
            }
          ),

          qText(
            "seal",
            "Seal number or dimensions",
            "Example: 10-19 or verified ID x OD",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "hub-drum",
        "Hub and brake drum / hub-drum",
        COLLECTIONS.drumsPlates,
        "trailer hub drum",
        "Confirm brake diameter and width, bearings, seal, bolt pattern, wheel pilot, stud size, drum depth, and compatible backing plate.",
        [
          shared.brakeSize,
          shared.boltPattern,

          qText(
            "inner_bearing",
            "Inner bearing number",
            "Example: L68149",
            "",
            {
              required: false
            }
          ),

          qText(
            "outer_bearing",
            "Outer bearing number",
            "Example: L44649",
            "",
            {
              required: false
            }
          ),

          qText(
            "casting",
            "Hub or drum casting number",
            "Enter all markings",
            "A casting number may have multiple machined configurations.",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "bearing-kit",
        "Bearing, race and seal kit",
        COLLECTIONS.bearings,
        "trailer bearing seal kit",
        "Use the bearing and seal numbers whenever possible. Axle capacity or bolt pattern alone may not identify the correct kit.",
        [
          qText(
            "inner_bearing",
            "Inner bearing number",
            "Example: L68149",
            "",
            {
              required: false
            }
          ),

          qText(
            "outer_bearing",
            "Outer bearing number",
            "Example: L44649",
            "",
            {
              required: false
            }
          ),

          qText(
            "seal",
            "Seal number",
            "Example: 10-19 or 171255TB",
            "",
            {
              required: false
            }
          ),

          shared.capacity
        ]
      ),

      task(
        "individual-bearing",
        "Individual bearing, race, seal, cap or spindle nut",
        COLLECTIONS.bearings,
        "trailer bearing race seal cap spindle nut",
        "Match the stamped number or verified dimensions. Similar-looking wheel-end components are not automatically interchangeable.",
        [
          qSelect(
            "component",
            "Component needed",
            [
              "Inner bearing",
              "Outer bearing",
              "Bearing race / cup",
              "Grease seal",
              "Dust or grease cap",
              "Spindle nut, washer, or retainer",
              "Other / unknown"
            ]
          ),

          shared.partNumber,

          qText(
            "dimensions",
            "Verified dimensions",
            "Enter ID, OD, width, bore, or thread",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "spindle",
        "Spindle or spindle repair kit",
        COLLECTIONS.spindles,
        "trailer axle spindle repair kit",
        "Spindle replacement is structural work. Confirm capacity, axle tube, bearing journals, seal surface, brake flange, weld procedure, and qualified installation.",
        [
          shared.capacity,

          qSelect(
            "spindle_style",
            "Spindle style",
            [
              "Straight spindle",
              "Tapered spindle",
              "Drop spindle",
              "Weld-in repair spindle",
              "Bolt-on spindle",
              "Not sure"
            ]
          ),

          qText(
            "bearing_surfaces",
            "Bearing and seal information",
            "Enter inner bearing, outer bearing, seal, or journal dimensions"
          ),

          qText(
            "tube",
            "Axle tube dimensions",
            "Outside diameter, wall thickness, and shape",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "brake_flange",
            "Brake flange",
            [
              "No flange",
              "4-bolt flange",
              "5-bolt flange",
              "Other / unknown"
            ]
          )
        ]
      ),

      task(
        "axle-hardware",
        "Axle seats, flanges and hardware",
        COLLECTIONS.axleParts,
        "trailer axle hardware spring seat brake flange",
        "Match the exact component, axle tube, thread, flange pattern, dimensions, material, and installation method.",
        [
          qSelect(
            "component",
            "Component needed",
            [
              "Spring seat / perch",
              "Brake flange",
              "Spindle washer or nut",
              "Grease fitting or plug",
              "Hub hardware",
              "Other / unknown"
            ]
          ),

          shared.capacity,

          qText(
            "dimensions",
            "Dimensions, thread, or flange pattern",
            "Enter all verified measurements",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "heavy-running-gear",
        "Heavy-duty running gear — 8,000 lb and above",
        COLLECTIONS.heavyRunning,
        "heavy duty trailer running gear 8000 10000 12000 16000",
        "Heavy-duty components require exact capacity, spindle, brake, hub, wheel, fastener, and manufacturer verification.",
        [
          shared.capacity,

          qSelect(
            "component",
            "Component needed",
            [
              "Axle or beam",
              "Hub or hub/drum",
              "Brake assembly",
              "Bearing or seal",
              "Suspension component",
              "Wheel-end hardware",
              "Other / unknown"
            ]
          ),

          qText(
            "manufacturer_number",
            "Manufacturer or casting number",
            "Enter Dexter, AL-KO, Lippert, Hayes, or other number",
            "",
            {
              required: false
            }
          )
        ],
        {
          trailerPriority: [
            "equipment",
            "dump",
            "flatbed"
          ]
        }
      ),

      task(
        "marine-running-gear",
        "Boat / marine running gear and UFP components",
        COLLECTIONS.marineRunning,
        "boat trailer UFP running gear",
        "Confirm manufacturer, model, dimensions, brake type, bearing and seal information, corrosion-resistant finish, and existing part numbers.",
        [
          qSelect(
            "component",
            "Marine component",
            [
              "Hub or rotor",
              "Drum brake",
              "Disc brake",
              "Actuator",
              "Bearing protector or cap",
              "Spindle or axle part",
              "UFP component",
              "Other / unknown"
            ]
          ),

          qText(
            "number",
            "Manufacturer, casting, or model number",
            "Enter all markings",
            "",
            {
              required: false
            }
          ),

          shared.capacity,
          shared.boltPattern
        ],
        {
          trailerPriority: [
            "boat"
          ]
        }
      )
    ],

    brakes: [
      task(
        "electric-brake-assembly",
        "Complete electric drum-brake assembly",
        COLLECTIONS.drumsPlates,
        "electric trailer brake backing plate assembly",
        "Confirm brake size, flange pattern, axle capacity, left or right orientation, manual or self-adjusting design, magnet, and drum compatibility.",
        [
          shared.brakeSize,

          qSelect(
            "flange_pattern",
            "Mounting-flange pattern",
            [
              "4-bolt flange",
              "5-bolt flange",
              "7-bolt flange",
              "Other / unknown"
            ]
          ),

          qSelect(
            "adjustment",
            "Adjustment type",
            [
              "Manual adjust",
              "Self-adjust",
              "Not sure"
            ]
          ),

          qSelect(
            "orientation",
            "Orientation or quantity",
            OPTIONS.side
          ),

          shared.capacity
        ]
      ),

      task(
        "electric-brake-service",
        "Electric brake shoes, magnets and hardware",
        COLLECTIONS.drumsPlates,
        "electric trailer brake shoes magnet hardware",
        "Match brake size, manufacturer or assembly number, orientation where applicable, adjuster style, magnet, and spring arrangement.",
        [
          qSelect(
            "component",
            "Service component",
            [
              "Magnet",
              "Brake shoes",
              "Adjuster",
              "Spring or hardware kit",
              "Lever or cable",
              "Mounting hardware",
              "Other / unknown"
            ]
          ),

          shared.brakeSize,

          qSelect(
            "adjustment",
            "Assembly type",
            [
              "Manual adjust",
              "Self-adjust",
              "Not sure"
            ]
          ),

          qText(
            "assembly_number",
            "Brake assembly or manufacturer number",
            "Enter all markings",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "orientation",
            "Side, if applicable",
            OPTIONS.side,
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "hydraulic-drum",
        "Hydraulic drum-brake assembly or service parts",
        COLLECTIONS.hydraulicBrakes,
        "hydraulic trailer drum brake",
        "Confirm brake size, flange pattern, free-backing or standard design, orientation, wheel-cylinder type, actuator pressure compatibility, and marine exposure.",
        [
          qSelect(
            "component",
            "Component needed",
            [
              "Complete backing plate",
              "Wheel cylinder",
              "Brake shoes",
              "Adjuster or spring hardware",
              "Drum or hub-drum",
              "Other / unknown"
            ]
          ),

          shared.brakeSize,

          qSelect(
            "design",
            "Hydraulic design",
            [
              "Standard hydraulic",
              "Free-backing",
              "Uni-servo or duo-servo known",
              "Not sure"
            ]
          ),

          qSelect(
            "orientation",
            "Orientation or quantity",
            OPTIONS.side
          ),

          qSelect(
            "environment",
            "Application",
            [
              "General trailer use",
              "Boat / marine trailer",
              "Other / unknown"
            ]
          )
        ]
      ),

      task(
        "hydraulic-disc",
        "Hydraulic disc-brake kit or components",
        COLLECTIONS.hydraulicBrakes,
        "hydraulic trailer disc brake caliper rotor kit",
        "Confirm capacity, rotor design, bolt pattern, spindle bearings and seal, caliper bracket, actuator pressure, brake-line interface, finish, and axle count.",
        [
          qSelect(
            "component",
            "Disc-brake component",
            [
              "Complete axle kit",
              "Hub / rotor",
              "Integral rotor",
              "Caliper",
              "Caliper bracket",
              "Pads",
              "Hardware",
              "Other / unknown"
            ]
          ),

          shared.capacity,
          shared.boltPattern,

          qSelect(
            "axle_count",
            "Number of braking axles",
            OPTIONS.axleCount
          ),

          qSelect(
            "finish",
            "Required environment or finish",
            [
              "General use",
              "Marine / corrosion-resistant",
              "Stainless components",
              "Coated",
              "Unknown"
            ]
          )
        ]
      ),

      task(
        "brake-drum",
        "Brake drum or hub/drum",
        COLLECTIONS.drumsPlates,
        "trailer brake drum hub drum",
        "Brake size and bolt pattern are not sufficient by themselves. Confirm bearings, seal, drum depth, pilot dimensions, studs, and compatible brake assembly.",
        [
          shared.brakeSize,
          shared.boltPattern,

          qSelect(
            "drum_style",
            "Drum style",
            [
              "Hub and drum combined",
              "Slip-on drum",
              "Drum only / unknown",
              "Other / unknown"
            ]
          ),

          qText(
            "bearings",
            "Bearing and seal numbers",
            "Enter inner bearing, outer bearing, and seal",
            "",
            {
              required: false
            }
          ),

          qText(
            "casting",
            "Casting or manufacturer number",
            "Enter all markings",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "surge-actuator",
        "Surge-brake actuator or master-cylinder parts",
        COLLECTIONS.hydraulicBrakes,
        "trailer surge brake actuator master cylinder",
        "Confirm actuator manufacturer and model, drum or disc output, capacity, ball size, mounting style, reverse lockout, and breakaway components.",
        [
          qSelect(
            "component",
            "Actuator component",
            [
              "Complete surge actuator",
              "Master cylinder",
              "Shock or damper",
              "Latch or coupler repair",
              "Reverse lockout solenoid",
              "Breakaway lever or cable",
              "Other / unknown"
            ]
          ),

          qSelect(
            "brake_system",
            "Brake system",
            [
              "Hydraulic drum",
              "Hydraulic disc",
              "System unknown"
            ]
          ),

          qText(
            "model",
            "Actuator manufacturer and model",
            "Enter all labels or casting numbers",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "ball_size",
            "Coupler ball size",
            OPTIONS.ballSize
          )
        ]
      ),

      task(
        "brake-lines",
        "Hydraulic brake lines, hoses, fittings and tees",
        COLLECTIONS.hydraulicBrakes,
        "trailer hydraulic brake hose line fitting",
        "Confirm fitting thread, flare type, hose or tube length, pressure compatibility, axle routing, mounting tabs, and corrosion environment.",
        [
          qSelect(
            "component",
            "Hydraulic component",
            [
              "Flexible brake hose",
              "Steel brake line",
              "Main line kit",
              "Axle line kit",
              "Tee, union, or adapter",
              "Bleeder or fitting",
              "Other / unknown"
            ]
          ),

          qText(
            "end_fittings",
            "End fittings and thread",
            "Example: 3/16 inverted flare female"
          ),

          qText(
            "length",
            "Required line or hose length",
            "Enter length and measurement points",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "axle_count",
            "Trailer axle arrangement",
            OPTIONS.axleCount,
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "brake-controller",
        "Brake controller or vehicle-specific harness",
        COLLECTIONS.brakeControls,
        "trailer brake controller wiring harness",
        "Confirm tow-vehicle year, make, model, factory tow package, connector, controller type, trailer brake type, and axle count.",
        [
          qSelect(
            "component",
            "Controller component",
            [
              "Complete brake controller",
              "Vehicle-specific plug-in harness",
              "Universal wiring harness",
              "Mounting bracket or remote control",
              "Other / unknown"
            ]
          ),

          qSelect(
            "controller_type",
            "Controller type",
            [
              "Proportional",
              "Time-delayed",
              "Factory integration",
              "Bluetooth or app-based",
              "Not sure"
            ]
          ),

          qText(
            "vehicle",
            "Tow vehicle",
            "Year, make, model, trim, and tow package"
          ),

          qSelect(
            "brake_type",
            "Trailer brake type",
            [
              "Electric drum",
              "Electric-over-hydraulic",
              "Both required",
              "Not sure"
            ]
          )
        ],
        {
          trailerPriority: [
            "tow-vehicle"
          ]
        }
      ),

      task(
        "breakaway",
        "Breakaway switch, battery, charger or complete kit",
        COLLECTIONS.breakaway,
        "trailer breakaway kit switch battery charger",
        "Confirm braking-system requirements, battery voltage and capacity, charger type, enclosure, switch cable, wiring, and applicable requirements.",
        [
          qSelect(
            "component",
            "Breakaway component",
            [
              "Complete breakaway kit",
              "Breakaway switch and cable",
              "Battery",
              "Battery box",
              "Charger or tester",
              "Replacement pin",
              "Other / unknown"
            ]
          ),

          qSelect(
            "brake_system",
            "Brake system",
            [
              "Electric drum",
              "Electric-over-hydraulic",
              "Hydraulic surge with mechanical breakaway",
              "Not sure"
            ]
          ),

          qText(
            "existing_number",
            "Existing kit or component number",
            "Enter manufacturer and model",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "axle_count",
            "Number of braking axles",
            OPTIONS.axleCount,
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "electric-over-hydraulic",
        "Electric-over-hydraulic actuator and controls",
        COLLECTIONS.hydraulicBrakes,
        "electric over hydraulic trailer brake actuator",
        "Confirm drum or disc output, pressure and capacity, controller compatibility, battery requirements, plumbing, mounting, and breakaway integration.",
        [
          qSelect(
            "brake_system",
            "Hydraulic brake type",
            [
              "Drum brakes",
              "Disc brakes",
              "Not sure"
            ]
          ),

          qSelect(
            "component",
            "Component needed",
            [
              "Complete EOH actuator",
              "Adapter module",
              "Wiring or control component",
              "Hydraulic fitting or line",
              "Other / unknown"
            ]
          ),

          qText(
            "model",
            "Existing actuator or controller number",
            "Enter manufacturer and model",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "axle_count",
            "Number of braking axles",
            OPTIONS.axleCount
          )
        ]
      ),

      task(
        "air-brakes",
        "Air-brake components",
        COLLECTIONS.airBrakes,
        "trailer air brake parts",
        "Air-brake components require exact manufacturer, model, port, chamber, stroke, mounting, pressure, and commercial-system verification.",
        [
          qSelect(
            "component",
            "Air-brake component",
            [
              "Brake chamber",
              "Valve",
              "Air line or fitting",
              "Slack adjuster",
              "Air tank component",
              "Other / unknown"
            ]
          ),

          shared.partNumber,

          qText(
            "system_details",
            "System and mounting details",
            "Enter chamber type, stroke, port size, mounting, and vehicle information",
            "",
            {
              required: false
            }
          )
        ]
      )
    ],

    suspension: [
      task(
        "leaf-spring",
        "Leaf spring",
        COLLECTIONS.suspension,
        "trailer leaf spring",
        "Confirm spring style, unloaded length, width, leaf count, arch, center bolt, bushing size, capacity, and axle arrangement.",
        [
          qSelect(
            "spring_style",
            "Spring style",
            [
              "Double-eye spring",
              "Slipper spring",
              "Open-eye spring",
              "Hook-end spring",
              "Other / unknown"
            ]
          ),

          qText(
            "length",
            "Spring length",
            "Example: 25-1/4 inches eye-to-eye",
            "Identify the measurement points."
          ),

          qSelect(
            "width",
            "Spring width",
            OPTIONS.springWidth
          ),

          qText(
            "leaf_count",
            "Number of leaves",
            "Example: 4 leaf",
            "Leaf count alone does not determine capacity.",
            {
              required: false
            }
          ),

          shared.capacity
        ]
      ),

      task(
        "suspension-kit",
        "Suspension rebuild or shackle kit",
        COLLECTIONS.suspension,
        "trailer suspension rebuild shackle wet bolt kit",
        "Confirm axle count, spring style, spring width, hanger spacing, equalizer dimensions, bolt diameter, shackle length, and bushing type.",
        [
          qSelect(
            "axle_count",
            "Axle arrangement",
            OPTIONS.axleCount
          ),

          qSelect(
            "spring_style",
            "Spring style",
            [
              "Double-eye",
              "Slipper",
              "Other / unknown"
            ]
          ),

          qSelect(
            "spring_width",
            "Spring width",
            OPTIONS.springWidth
          ),

          qText(
            "equalizer_dimensions",
            "Equalizer dimensions or number",
            "Enter center-hole spacing and height",
            "",
            {
              required: false
            }
          ),

          qText(
            "shackle_length",
            "Shackle-link hole spacing",
            "Enter center-to-center length",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "equalizer",
        "Equalizer",
        COLLECTIONS.suspension,
        "trailer suspension equalizer",
        "Confirm spring style, axle spacing, hole spacing, height, width, bolt diameter, and rigid or cushioned design.",
        [
          qSelect(
            "equalizer_type",
            "Equalizer type",
            [
              "Standard rigid equalizer",
              "Cushioned equalizer",
              "Slipper-spring equalizer",
              "Manufacturer-specific equalizer",
              "Other / unknown"
            ]
          ),

          qText(
            "dimensions",
            "Equalizer dimensions",
            "Center hole to side holes, height, and width"
          ),

          qText(
            "bolt_diameter",
            "Bolt-hole diameter",
            "Example: 9/16 inch",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "axle_count",
            "Axle arrangement",
            OPTIONS.axleCount,
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "u-bolts",
        "U-bolts, tie plates and axle mounting hardware",
        COLLECTIONS.suspension,
        "trailer axle u bolt tie plate kit",
        "Confirm axle tube shape and diameter, spring width, U-bolt diameter, inside width, leg length, thread, tie plate, and axle position.",
        [
          qSelect(
            "tube_shape",
            "Axle tube shape",
            [
              "Round",
              "Square",
              "Rectangular",
              "Other / unknown"
            ]
          ),

          qText(
            "tube_size",
            "Axle tube size",
            "Example: 2-3/8 inch round"
          ),

          qSelect(
            "spring_width",
            "Spring width",
            OPTIONS.springWidth
          ),

          qText(
            "u_bolt_size",
            "U-bolt diameter and leg length",
            "Example: 1/2 inch x 6-1/2 inch",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "mounting",
            "Axle position",
            [
              "Axle above spring",
              "Axle below spring",
              "Not sure"
            ]
          )
        ]
      ),

      task(
        "hanger-kit",
        "Spring hanger kit",
        COLLECTIONS.suspension,
        "trailer leaf spring hanger kit",
        "Confirm axle count, spring style, spring length, hanger spacing, frame dimensions, equalizer geometry, shackle length, and weld-on layout.",
        [
          qSelect(
            "axle_count",
            "Axle arrangement",
            OPTIONS.axleCount
          ),

          qSelect(
            "spring_style",
            "Spring style",
            [
              "Double-eye",
              "Slipper",
              "Other / unknown"
            ]
          ),

          qText(
            "spring_length",
            "Spring length",
            "Enter eye-to-eye or eye-to-end measurement"
          ),

          qText(
            "hanger_spacing",
            "Existing hanger spacing",
            "Enter center-to-center measurements",
            "",
            {
              required: false
            }
          ),

          qNote(
            "Weld-on hanger layout and installation should be performed by a qualified trailer fabricator."
          )
        ]
      ),

      task(
        "suspension-hardware",
        "Shackle links, bolts and bushings",
        COLLECTIONS.suspension,
        "trailer shackle bolt bushing suspension hardware",
        "Confirm bolt diameter, usable length, thread, grease passage, bushing ID and OD, shackle hole spacing, material, and quantity.",
        [
          qSelect(
            "component",
            "Suspension component",
            [
              "Shackle link",
              "Standard suspension bolt",
              "Wet bolt",
              "Bronze bushing",
              "Nylon bushing",
              "Lock nut",
              "Other / unknown"
            ]
          ),

          qText(
            "dimensions",
            "Required dimensions",
            "Enter bolt diameter, length, hole spacing, and bushing dimensions"
          ),

          shared.quantity
        ]
      )
    ],

    towing: [
      task(
        "trailer-coupler",
        "Trailer coupler",
        COLLECTIONS.couplers,
        "trailer tongue coupler",
        "Confirm tongue style and dimensions, ball size, capacity, mounting method, channel width, bolt pattern, latch design, and braking integration.",
        [
          qSelect(
            "coupler_style",
            "Coupler style",
            [
              "Straight-tongue coupler",
              "A-frame coupler",
              "Adjustable-channel coupler",
              "Gooseneck coupler",
              "Surge-brake actuator coupler",
              "Other / unknown"
            ]
          ),

          qSelect(
            "ball_size",
            "Hitch-ball size",
            OPTIONS.ballSize
          ),

          qSelect(
            "mounting",
            "Mounting method",
            [
              "Bolt-on",
              "Weld-on",
              "Adjustable channel",
              "Other / unknown"
            ]
          ),

          qText(
            "tongue_size",
            "Tongue or channel dimensions",
            "Example: 3 inch channel",
            "",
            {
              required: false
            }
          ),

          qText(
            "capacity",
            "Required rated capacity",
            "Enter verified requirement",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "coupler-repair",
        "Coupler latch or repair kit",
        COLLECTIONS.couplers,
        "trailer coupler latch repair kit",
        "Coupler repair parts are commonly manufacturer- and model-specific. Confirm brand, model, ball size, latch design, casting, and dimensions.",
        [
          qSelect(
            "component",
            "Repair component",
            [
              "Latch repair kit",
              "Handle or lever",
              "Ball clamp or wedge",
              "Pin or spring",
              "Coupler lock hardware",
              "Other / unknown"
            ]
          ),

          qText(
            "brand_model",
            "Coupler brand and model",
            "Enter labels, casting numbers, or stamped numbers"
          ),

          qSelect(
            "ball_size",
            "Ball size",
            OPTIONS.ballSize,
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "safety-chain",
        "Safety chain, cable or hook",
        COLLECTIONS.safetyChains,
        "trailer safety chain cable hook",
        "Confirm rated capacity, chain grade where specified, length, hook style, attachment method, mounting hardware, and turning clearance.",
        [
          qSelect(
            "component",
            "Safety component",
            [
              "Complete safety chain",
              "Safety cable",
              "Clevis hook",
              "S-hook",
              "Chain retainer",
              "Mounting hardware",
              "Other / unknown"
            ]
          ),

          qText(
            "rating",
            "Required rating",
            "Enter verified working-load or capacity requirement"
          ),

          qText(
            "length",
            "Required length",
            "Enter total chain or cable length",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "mounting",
            "Trailer-end attachment",
            [
              "Welded",
              "Bolted",
              "Clevis-mounted",
              "Existing attachment reused",
              "Other / unknown"
            ]
          )
        ]
      ),

      task(
        "hitch-ball",
        "Hitch ball",
        COLLECTIONS.hitchBalls,
        "trailer hitch ball",
        "Confirm ball diameter, shank diameter, shank length, capacity, platform thickness, wrench clearance, and finish.",
        [
          qSelect(
            "ball_size",
            "Ball diameter",
            OPTIONS.ballSize
          ),

          qText(
            "shank",
            "Shank diameter and usable length",
            "Example: 1 inch x 2-1/8 inch"
          ),

          qText(
            "rating",
            "Required capacity",
            "Enter verified towing requirement",
            "",
            {
              required: false
            }
          )
        ],
        {
          trailerPriority: [
            "tow-vehicle"
          ]
        }
      ),

      task(
        "ball-mount",
        "Receiver ball mount",
        COLLECTIONS.ballMounts,
        "receiver hitch ball mount",
        "Confirm receiver size, rise or drop, ball-hole diameter, capacity, loaded coupler height, receiver height, and clearance.",
        [
          qSelect(
            "receiver_size",
            "Receiver size",
            OPTIONS.receiverSize
          ),

          qText(
            "rise_drop",
            "Required rise or drop",
            "Enter inches of rise or drop",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "mount_style",
            "Mount style",
            [
              "Fixed ball mount",
              "Adjustable ball mount",
              "Multi-ball mount",
              "Other / unknown"
            ]
          ),

          qText(
            "rating",
            "Required capacity",
            "Enter verified trailer and tongue-weight requirement",
            "",
            {
              required: false
            }
          )
        ],
        {
          trailerPriority: [
            "tow-vehicle"
          ]
        }
      ),

      task(
        "pintle",
        "Pintle hook, lunette ring or combination hitch",
        COLLECTIONS.pintle,
        "pintle hook lunette ring trailer",
        "Confirm lunette diameter and thickness, pintle rating, mounting pattern, receiver or plate style, drawbar height, and articulation requirements.",
        [
          qSelect(
            "component",
            "Pintle component",
            [
              "Pintle hook",
              "Lunette ring",
              "Combination ball and pintle",
              "Pintle mount",
              "Latch repair component",
              "Other / unknown"
            ]
          ),

          qText(
            "dimensions",
            "Lunette or mounting dimensions",
            "Enter eye ID, eye thickness, bolt pattern, or receiver size"
          ),

          qText(
            "rating",
            "Required capacity",
            "Enter verified towing requirement",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "receiver-hitch",
        "Tow-vehicle receiver hitch",
        COLLECTIONS.receivers,
        "truck receiver hitch",
        "Vehicle fitment must be verified by year, make, model, body style, drivetrain, bumper, exhaust, frame, hitch class, and manufacturer application.",
        [
          qText(
            "vehicle",
            "Tow vehicle",
            "Year, make, model, trim, cab, bed, and drivetrain"
          ),

          qSelect(
            "receiver_size",
            "Receiver opening",
            OPTIONS.receiverSize
          ),

          qText(
            "rating",
            "Required towing capacity",
            "Enter verified vehicle and trailer requirements",
            "",
            {
              required: false
            }
          )
        ],
        {
          trailerPriority: [
            "tow-vehicle"
          ]
        }
      ),

      task(
        "weight-distribution",
        "Weight-distribution or sway-control components",
        COLLECTIONS.weightDistribution,
        "weight distribution sway control hitch",
        "Confirm loaded trailer weight, loaded tongue weight, receiver rating, coupler style, frame clearance, bracket location, and manufacturer setup requirements.",
        [
          qSelect(
            "component",
            "Component needed",
            [
              "Complete weight-distribution kit",
              "Spring bars",
              "Shank",
              "Head assembly",
              "Frame brackets",
              "Friction sway control",
              "Replacement hardware",
              "Other / unknown"
            ]
          ),

          qText(
            "tongue_weight",
            "Loaded tongue weight",
            "Enter measured loaded tongue weight"
          ),

          qText(
            "trailer_weight",
            "Loaded trailer weight",
            "Enter verified loaded trailer weight",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "receiver_size",
            "Receiver size",
            OPTIONS.receiverSize,
            "",
            {
              required: false
            }
          )
        ],
        {
          trailerPriority: [
            "tow-vehicle"
          ]
        }
      )
    ],

    jacks: [
      task(
        "trailer-jack",
        "Complete trailer jack",
        COLLECTIONS.jacks,
        "trailer tongue jack",
        "Confirm jack style, lift and support rating, travel, retracted and extended height, mounting, tube size, handle orientation, foot, and clearance.",
        [
          qSelect(
            "jack_style",
            "Jack style",
            [
              "A-frame jack",
              "Swivel tongue jack",
              "Drop-leg jack",
              "Pipe-mount jack",
              "Square-tube jack",
              "Electric tongue jack",
              "Other / unknown"
            ]
          ),

          qText(
            "capacity",
            "Required jack rating",
            "Enter verified lift or support requirement"
          ),

          qText(
            "travel",
            "Required travel",
            "Example: 15 inches",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "mounting",
            "Mounting method",
            [
              "Bolt-on",
              "Weld-on",
              "A-frame flange",
              "Pipe mount",
              "Existing bracket",
              "Other / unknown"
            ]
          ),

          qSelect(
            "foot",
            "Bottom support",
            [
              "Fixed foot",
              "Drop leg",
              "Caster wheel",
              "No foot included",
              "Other / unknown"
            ]
          )
        ]
      ),

      task(
        "jack-repair",
        "Jack handle, gear, pin, foot or repair component",
        COLLECTIONS.jacks,
        "trailer jack repair parts",
        "Jack repair parts are commonly brand- and model-specific. Confirm manufacturer, model, tube size, gear arrangement, handle, pin, foot, and rating.",
        [
          qSelect(
            "component",
            "Jack component",
            [
              "Handle",
              "Gear set",
              "Crank",
              "Mounting bracket",
              "Swivel pin",
              "Foot plate",
              "Drop leg",
              "Caster wheel",
              "Other / unknown"
            ]
          ),

          qText(
            "brand_model",
            "Jack brand and model",
            "Enter label, casting, or stamped number"
          ),

          qText(
            "dimensions",
            "Relevant dimensions",
            "Enter tube size, pin diameter, gear size, or mounting dimensions",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "landing-gear",
        "Gooseneck or fifth-wheel landing gear",
        COLLECTIONS.jacks,
        "trailer landing gear leg",
        "Confirm manufacturer, model, leg dimensions, mounting brackets, gearbox ratio, shaft arrangement, drop-leg style, capacity, and configuration.",
        [
          qSelect(
            "component",
            "Landing-gear component",
            [
              "Complete leg",
              "Lead leg",
              "Follower leg",
              "Gearbox",
              "Cross shaft",
              "Crank handle",
              "Drop leg or pin",
              "Motor kit",
              "Other / unknown"
            ]
          ),

          qText(
            "brand_model",
            "Manufacturer and model",
            "Enter all labels and stamped numbers"
          ),

          qText(
            "dimensions",
            "Leg and mounting dimensions",
            "Enter tube size, bracket spacing, travel, and shaft details",
            "",
            {
              required: false
            }
          )
        ],
        {
          trailerPriority: [
            "flatbed",
            "equipment",
            "dump"
          ]
        }
      ),

      task(
        "stabilizer",
        "Stabilizer jack or support",
        COLLECTIONS.jacks,
        "trailer stabilizer jack",
        "Stabilizer jacks are not automatically suitable for lifting. Confirm support rating, travel, mounting orientation, dimensions, clearance, and intended use.",
        [
          qSelect(
            "style",
            "Stabilizer style",
            [
              "Scissor jack",
              "Drop-down stabilizer",
              "Corner steady",
              "Telescoping stabilizer",
              "Other / unknown"
            ]
          ),

          qText(
            "rating",
            "Required support rating",
            "Enter verified requirement",
            "",
            {
              required: false
            }
          ),

          qText(
            "mounting",
            "Mounting dimensions",
            "Enter bolt pattern or bracket dimensions",
            "",
            {
              required: false
            }
          )
        ]
      )
    ],

    lighting: [
      task(
        "tail-light",
        "Tail, stop and turn light",
        COLLECTIONS.lighting,
        "trailer tail stop turn light",
        "Confirm function, shape, dimensions, mounting, connector, voltage, orientation, license illumination, reflector requirements, and application.",
        [
          qSelect(
            "technology",
            "Light type",
            [
              "LED",
              "Incandescent",
              "Either / unknown"
            ]
          ),

          qSelect(
            "shape",
            "Light shape",
            [
              "Round",
              "Oval",
              "Rectangular",
              "Square",
              "Bar / strip",
              "Other / unknown"
            ]
          ),

          qSelect(
            "mounting",
            "Mounting method",
            [
              "Surface mount",
              "Grommet mount",
              "Stud mount",
              "Bracket mount",
              "Other / unknown"
            ]
          ),

          qSelect(
            "orientation",
            "Side or quantity",
            OPTIONS.side
          ),

          qText(
            "dimensions",
            "Light dimensions",
            "Enter housing and mounting-opening dimensions",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "marker-light",
        "Clearance, marker or identification light",
        COLLECTIONS.lighting,
        "trailer clearance marker identification light",
        "Confirm color and function, dimensions, mounting, connector, voltage, lens, reflector rating, and installation location.",
        [
          qSelect(
            "function",
            "Light function",
            [
              "Amber side marker",
              "Red side marker",
              "Clearance light",
              "Three-light identification bar",
              "Combination marker / reflector",
              "Other / unknown"
            ]
          ),

          qSelect(
            "technology",
            "Light type",
            [
              "LED",
              "Incandescent",
              "Either / unknown"
            ]
          ),

          qSelect(
            "mounting",
            "Mounting method",
            [
              "Surface mount",
              "Grommet mount",
              "Stud mount",
              "Bracket mount",
              "Other / unknown"
            ]
          ),

          qText(
            "dimensions",
            "Dimensions or hole spacing",
            "Enter verified measurements",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "light-kit",
        "Complete trailer light and wiring kit",
        COLLECTIONS.lighting,
        "complete trailer light wiring kit",
        "Confirm trailer width and length, required light functions, connector, side-marker count, license light, wiring length, and submersible requirement.",
        [
          qSelect(
            "trailer_width",
            "Trailer width",
            [
              "Under 80 inches",
              "80 inches or wider",
              "Not sure"
            ]
          ),

          qSelect(
            "technology",
            "Lighting type",
            [
              "LED",
              "Incandescent",
              "Either / unknown"
            ]
          ),

          qSelect(
            "plug",
            "Tow-vehicle connector",
            OPTIONS.plugType
          ),

          qSelect(
            "environment",
            "Application",
            [
              "General utility or cargo trailer",
              "Boat / submersible trailer",
              "Heavy equipment trailer",
              "Other / unknown"
            ]
          ),

          qText(
            "length",
            "Approximate trailer length",
            "Enter overall length",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "trailer-plug",
        "Trailer plug, connector, cord or adapter",
        COLLECTIONS.plugs,
        "trailer plug connector cord adapter",
        "Confirm connector style, pin count, blade or round-pin arrangement, vehicle or trailer side, male or female end, cable gauge, length, and required functions.",
        [
          qSelect(
            "connector",
            "Connector style",
            OPTIONS.plugType
          ),

          qSelect(
            "side",
            "Connection side",
            [
              "Trailer-side plug",
              "Vehicle-side socket",
              "Extension cord",
              "Adapter",
              "Junction connection",
              "Other / unknown"
            ]
          ),

          qText(
            "length",
            "Cord or lead length",
            "Enter required length",
            "",
            {
              required: false
            }
          ),

          qText(
            "functions",
            "Required circuits",
            "Example: lights, brakes, power, reverse",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "trailer-wiring",
        "Trailer wiring harness, junction box or wire",
        COLLECTIONS.trailerWiring,
        "trailer wiring harness junction box",
        "Confirm connector, conductor count and gauge, cable length, circuit functions, brake wiring, junction terminals, protection, and routing.",
        [
          qSelect(
            "component",
            "Wiring component",
            [
              "Complete trailer harness",
              "Junction box",
              "Bonded trailer wire",
              "Brake wire",
              "Ground wire",
              "Wire loom",
              "Terminals and connectors",
              "Other / unknown"
            ]
          ),

          qSelect(
            "plug",
            "Connector style",
            OPTIONS.plugType,
            "",
            {
              required: false
            }
          ),

          qText(
            "wire",
            "Wire count, gauge, or length",
            "Example: 7 conductor, 25 feet",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "brakes",
            "Electric trailer brakes present",
            OPTIONS.yesNoUnknown
          )
        ]
      ),

      task(
        "tow-vehicle-wiring",
        "Tow-vehicle wiring kit or converter",
        COLLECTIONS.truckWiring,
        "tow vehicle trailer wiring converter harness",
        "Vehicle wiring must be verified by year, make, model, trim, tow package, connector location, lighting system, converter requirement, and brake integration.",
        [
          qText(
            "vehicle",
            "Tow vehicle",
            "Year, make, model, trim, and factory tow package"
          ),

          qSelect(
            "output",
            "Required trailer connector",
            OPTIONS.plugType
          ),

          qSelect(
            "component",
            "Wiring component",
            [
              "Vehicle-specific T-connector",
              "Powered converter",
              "Universal converter",
              "Replacement socket",
              "Brake-controller wiring",
              "Other / unknown"
            ]
          )
        ],
        {
          trailerPriority: [
            "tow-vehicle"
          ]
        }
      ),

      task(
        "interior-light",
        "Cargo, dome or interior trailer light",
        COLLECTIONS.lighting,
        "trailer cargo dome interior light",
        "Confirm voltage, output, housing dimensions, switch arrangement, mounting, wire entry, power source, and moisture exposure.",
        [
          qSelect(
            "technology",
            "Light type",
            [
              "LED",
              "Incandescent",
              "Fluorescent-style replacement",
              "Other / unknown"
            ]
          ),

          qSelect(
            "switch",
            "Switch arrangement",
            [
              "Built-in switch",
              "Remote wall switch",
              "Door switch",
              "No switch",
              "Other / unknown"
            ]
          ),

          qText(
            "dimensions",
            "Fixture dimensions",
            "Enter length, width, depth, or hole spacing",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "power",
            "Power source",
            [
              "Tow-vehicle auxiliary circuit",
              "Onboard trailer battery",
              "Converter or shore-power system",
              "Not sure"
            ]
          )
        ],
        {
          trailerPriority: [
            "enclosed",
            "horse",
            "rv"
          ]
        }
      ),

      task(
        "light-accessory",
        "Replacement lens, grommet, bracket or pigtail",
        COLLECTIONS.lightMounting,
        "trailer light lens grommet bracket pigtail",
        "Match the light manufacturer, model, housing dimensions, lens markings, opening, connector, bracket spacing, and orientation.",
        [
          qSelect(
            "component",
            "Lighting accessory",
            [
              "Replacement lens",
              "Rubber grommet",
              "Mounting bracket",
              "Pigtail or connector",
              "Light guard",
              "License bracket",
              "Other / unknown"
            ]
          ),

          qText(
            "light_number",
            "Light or lens number",
            "Enter all molded or printed numbers",
            "",
            {
              required: false
            }
          ),

          qText(
            "dimensions",
            "Housing or opening dimensions",
            "Enter width, height, diameter, and hole spacing",
            "",
            {
              required: false
            }
          )
        ]
      )
    ],

    doors: [
      task(
        "ramp-hinge",
        "Ramp or door hinge",
        COLLECTIONS.ramps,
        "trailer ramp door hinge",
        "Confirm hinge style, pin diameter, leaf dimensions, mounting, material, load, orientation, grease provisions, and quantity.",
        [
          qSelect(
            "hinge_style",
            "Hinge style",
            [
              "Weld-on barrel hinge",
              "Bolt-on strap hinge",
              "Continuous hinge",
              "Ramp hinge",
              "Gate hinge",
              "Other / unknown"
            ]
          ),

          qText(
            "dimensions",
            "Hinge dimensions",
            "Enter pin diameter, barrel length, leaf size, and hole spacing"
          ),

          qSelect(
            "orientation",
            "Orientation",
            [
              "Left",
              "Right",
              "Universal",
              "Pair",
              "Not sure"
            ]
          )
        ]
      ),

      task(
        "ramp-spring",
        "Ramp spring, assist spring or cable hardware",
        COLLECTIONS.ramps,
        "trailer ramp spring assist",
        "Confirm spring-system type, door or ramp weight, shaft diameter, winding direction, spring dimensions, cable arrangement, and brackets.",
        [
          qSelect(
            "system",
            "Assist system",
            [
              "Torsion spring and shaft",
              "Coil spring",
              "Cable and drum",
              "Spring-assist hinge",
              "Other / unknown"
            ]
          ),

          qSelect(
            "orientation",
            "Side or winding direction",
            [
              "Left-hand",
              "Right-hand",
              "Pair",
              "Unknown"
            ]
          ),

          qText(
            "dimensions",
            "Spring or shaft dimensions",
            "Enter wire diameter, coil diameter, length, and shaft size"
          ),

          qNote(
            "Ramp-spring systems store hazardous energy. Verify installation procedure and tension before installation."
          )
        ]
      ),

      task(
        "door-latch",
        "Door latch, cam bar, handle or holdback",
        COLLECTIONS.doorHardware,
        "trailer door latch handle holdback",
        "Confirm door type, latch style, bar diameter, handle length, keeper dimensions, hole spacing, orientation, lockability, and material.",
        [
          qSelect(
            "component",
            "Door component",
            [
              "Cam-bar latch",
              "Paddle latch",
              "T-handle",
              "L-handle",
              "Door keeper",
              "Door holdback",
              "Grab handle",
              "Other / unknown"
            ]
          ),

          qText(
            "dimensions",
            "Component dimensions",
            "Enter bar diameter, handle length, hole spacing, and cutout"
          ),

          qSelect(
            "orientation",
            "Orientation",
            OPTIONS.side,
            "",
            {
              required: false
            }
          ),

          qSelect(
            "lockable",
            "Locking requirement",
            [
              "Lockable",
              "Non-locking",
              "Either",
              "Not sure"
            ]
          )
        ]
      ),

      task(
        "gas-strut",
        "Gas strut and mounting hardware",
        COLLECTIONS.gasStruts,
        "trailer gas strut lift support",
        "Confirm extended length, compressed length, force, end fittings, orientation, mounting geometry, temperature, door weight, and bracket dimensions.",
        [
          qText(
            "number",
            "Existing strut number",
            "Enter printed numbers and force markings",
            "",
            {
              required: false
            }
          ),

          qText(
            "extended",
            "Extended length",
            "Measure center-to-center of end fittings"
          ),

          qText(
            "compressed",
            "Compressed length",
            "Measure center-to-center",
            "",
            {
              required: false
            }
          ),

          qText(
            "force",
            "Force rating",
            "Example: 60 lb or 300 N",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "ends",
            "End fitting",
            [
              "10 mm ball socket",
              "Eyelet",
              "Clevis",
              "Threaded end",
              "Other / unknown"
            ]
          )
        ]
      ),

      task(
        "trim-seal",
        "Door seal, edge trim or weather stripping",
        COLLECTIONS.trimsSeals,
        "trailer door seal edge trim weatherstrip",
        "Confirm profile, dimensions, grip range, bulb location, material, mounting, corner treatment, length, and exposure.",
        [
          qSelect(
            "component",
            "Seal or trim type",
            [
              "Push-on bulb seal",
              "Adhesive weatherstrip",
              "Rubber edge trim",
              "Door sweep",
              "Hatch seal",
              "Other / unknown"
            ]
          ),

          qText(
            "profile",
            "Profile dimensions",
            "Enter bulb diameter, channel width, grip range, and flange location"
          ),

          qText(
            "length",
            "Required length",
            "Enter total feet or inches",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "vent",
        "Trailer or RV vent",
        COLLECTIONS.vents,
        "trailer roof side vent",
        "Confirm opening dimensions, roof or wall thickness, flange, powered or passive operation, voltage, lid style, screen, garnish depth, and sealing.",
        [
          qSelect(
            "vent_type",
            "Vent type",
            [
              "Roof vent",
              "Sidewall vent",
              "Powered roof vent",
              "Plumbing vent",
              "Refrigerator vent",
              "Other / unknown"
            ]
          ),

          qText(
            "opening",
            "Rough opening",
            "Enter width and height"
          ),

          qText(
            "thickness",
            "Roof or wall thickness",
            "Enter finished thickness",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "power",
            "Powered operation",
            [
              "12-volt powered",
              "Passive / non-powered",
              "Not sure"
            ]
          )
        ]
      )
    ],

    cargo: [
      task(
        "tie-down",
        "D-ring, tie-down anchor or mounting plate",
        COLLECTIONS.tieDowns,
        "trailer d ring tie down anchor",
        "Confirm working-load limit, breaking strength, mounting method, backing requirements, bolt pattern, dimensions, orientation, and load direction.",
        [
          qSelect(
            "component",
            "Tie-down style",
            [
              "Surface-mount D-ring",
              "Recessed D-ring",
              "Weld-on D-ring",
              "Stake-pocket tie-down",
              "Floor anchor",
              "Backing plate",
              "Other / unknown"
            ]
          ),

          qText(
            "rating",
            "Required working-load limit",
            "Enter verified load requirement"
          ),

          qSelect(
            "mounting",
            "Mounting method",
            [
              "Bolt-on",
              "Weld-on",
              "Recessed",
              "Stake-pocket",
              "Other / unknown"
            ]
          ),

          qText(
            "dimensions",
            "Mounting dimensions",
            "Enter plate size, hole spacing, and ring dimensions",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "e-track",
        "E-Track, X-Track or track accessories",
        COLLECTIONS.tieDowns,
        "trailer e track x track accessories",
        "Confirm track style, length, mounting surface, fastener spacing, backing, load direction, fitting type, and working-load requirements.",
        [
          qSelect(
            "component",
            "Track component",
            [
              "Horizontal E-Track",
              "Vertical E-Track",
              "X-Track",
              "Track fitting",
              "Track strap",
              "Wood-beam socket",
              "Wheel-chock fitting",
              "Other / unknown"
            ]
          ),

          qText(
            "length",
            "Required track or strap length",
            "Enter verified length",
            "",
            {
              required: false
            }
          ),

          qText(
            "rating",
            "Required working-load limit",
            "Enter verified securement requirement",
            "",
            {
              required: false
            }
          ),

          qText(
            "mounting",
            "Mounting surface and backing",
            "Describe floor, wall, frame, or crossmember attachment"
          )
        ]
      ),

      task(
        "strap-chain",
        "Ratchet strap, binder, chain or hook",
        COLLECTIONS.strapsChains,
        "trailer cargo strap binder chain",
        "Confirm working-load limit, chain grade, strap width and length, hook style, load type, anchor points, and securement requirements.",
        [
          qSelect(
            "component",
            "Cargo-control component",
            [
              "Ratchet strap",
              "Winch strap",
              "Transport chain",
              "Ratchet binder",
              "Lever binder",
              "Replacement hook",
              "Other / unknown"
            ]
          ),

          qText(
            "rating",
            "Required working-load limit",
            "Enter verified requirement"
          ),

          qText(
            "length",
            "Required length",
            "Enter strap or chain length",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "end",
            "End fitting",
            [
              "Flat hook",
              "Wire hook",
              "Chain extension",
              "Grab hook",
              "Clevis hook",
              "Loop end",
              "Other / unknown"
            ]
          )
        ]
      ),

      task(
        "winch",
        "Trailer winch or winch component",
        COLLECTIONS.winches,
        "trailer winch strap cable handle",
        "Confirm winch type, pulling capacity, load angle, gear ratio, drum capacity, strap or cable compatibility, mounting, brake or ratchet design, and intended use.",
        [
          qSelect(
            "winch_type",
            "Winch type",
            [
              "Manual hand winch",
              "Brake winch",
              "Boat-trailer winch",
              "Electric winch",
              "Underbody spare-tire winch",
              "Other / unknown"
            ]
          ),

          qSelect(
            "component",
            "Component needed",
            [
              "Complete winch",
              "Winch strap",
              "Cable",
              "Hook",
              "Handle",
              "Mounting hardware",
              "Other / unknown"
            ]
          ),

          qText(
            "rating",
            "Required pulling capacity",
            "Enter verified load and application requirement"
          ),

          qText(
            "mounting",
            "Mounting-hole pattern",
            "Enter hole spacing and platform dimensions",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "lock-security",
        "Trailer lock or security product",
        COLLECTIONS.locks,
        "trailer coupler lock wheel lock security",
        "Confirm coupler style, ball size, latch geometry, receiver size, wheel dimensions, clearance, keying preference, and parked or connected use.",
        [
          qSelect(
            "lock_type",
            "Security product",
            [
              "Coupler lock — unhitched",
              "Coupler latch lock — hitched",
              "Receiver lock",
              "Wheel lock",
              "Door lock",
              "Kingpin lock",
              "Other / unknown"
            ]
          ),

          qSelect(
            "ball_size",
            "Coupler ball size",
            OPTIONS.ballSize,
            "",
            {
              required: false
            }
          ),

          qText(
            "dimensions",
            "Relevant dimensions",
            "Enter latch-hole diameter, receiver size, coupler width, or wheel size",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "spare-tire-mount",
        "Spare tire carrier",
        COLLECTIONS.spareMounts,
        "trailer spare tire mount",
        "Confirm bolt pattern, tire and wheel size, mounting surface, frame dimensions, offset, stud size, weight, clearance, and locking requirements.",
        [
          shared.boltPattern,
          shared.wheelSize,

          qSelect(
            "mounting",
            "Mounting location",
            [
              "Trailer tongue",
              "Frame rail",
              "Sidewall",
              "Rear bumper",
              "Underbody",
              "Other / unknown"
            ]
          ),

          qText(
            "frame",
            "Frame or mounting dimensions",
            "Enter tube width, height, wall thickness, or bolt pattern",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "wheel-chock",
        "Wheel chock or wheel stop",
        COLLECTIONS.wheelChocks,
        "trailer wheel chock",
        "Confirm tire diameter and width, trailer weight, surface, portable or mounted use, tandem-wheel spacing, material, and rating.",
        [
          qSelect(
            "style",
            "Chock style",
            [
              "Portable wedge chock",
              "Rubber chock",
              "Mounted wheel stop",
              "Tandem-wheel stabilizing chock",
              "Motorcycle wheel chock",
              "Other / unknown"
            ]
          ),

          shared.wheelSize,

          qText(
            "tire_width",
            "Tire width",
            "Enter tread width",
            "",
            {
              required: false
            }
          )
        ]
      )
    ],

    wheels: [
      task(
        "tire-wheel-assembly",
        "Mounted tire and wheel assembly",
        COLLECTIONS.wheels,
        "trailer tire wheel assembly",
        "Confirm tire size, load range, wheel size, bolt pattern, offset, center pilot, stud size, tire construction, speed rating, and required capacity.",
        [
          qText(
            "tire_size",
            "Tire size",
            "Example: ST205/75R15"
          ),

          qSelect(
            "construction",
            "Tire construction",
            [
              "Radial",
              "Bias",
              "Either / unknown"
            ]
          ),

          shared.boltPattern,

          qText(
            "load_range",
            "Load range",
            "Example: Load Range D",
            "",
            {
              required: false
            }
          ),

          qText(
            "offset",
            "Wheel offset",
            "Enter zero, positive, negative, or unknown",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "trailer-tire",
        "Trailer tire only",
        COLLECTIONS.wheels,
        "ST trailer tire",
        "Confirm complete tire size, load range, maximum load, speed rating, radial or bias construction, rim width range, inflation pressure, and service condition.",
        [
          qText(
            "tire_size",
            "Tire size",
            "Example: ST225/75R15"
          ),

          qSelect(
            "construction",
            "Construction",
            [
              "Radial",
              "Bias",
              "Either / unknown"
            ]
          ),

          qText(
            "load_range",
            "Load range",
            "Example: Load Range E"
          ),

          qText(
            "speed",
            "Required speed rating",
            "Enter sidewall symbol or requirement",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "trailer-wheel",
        "Trailer wheel / rim",
        COLLECTIONS.wheels,
        "trailer wheel rim",
        "Confirm diameter, width, bolt pattern, center pilot, offset, stud size and seat type, wheel capacity, material, and tire compatibility.",
        [
          shared.wheelSize,
          shared.boltPattern,

          qText(
            "width",
            "Wheel width",
            "Example: 6 inches"
          ),

          qText(
            "pilot",
            "Center-pilot diameter",
            "Enter inches or millimeters",
            "",
            {
              required: false
            }
          ),

          qText(
            "offset",
            "Wheel offset",
            "Enter verified offset",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "lug-hardware",
        "Lug nut, wheel stud or wheel bolt",
        COLLECTIONS.wheels,
        "trailer lug nut wheel stud bolt",
        "Confirm thread diameter and pitch, stud knurl and length, shoulder, seat style, hex size, wheel material, hub thickness, and quantity.",
        [
          qSelect(
            "component",
            "Wheel fastener",
            [
              "Lug nut",
              "Press-in wheel stud",
              "Screw-in wheel stud",
              "Wheel bolt",
              "Lug washer",
              "Other / unknown"
            ]
          ),

          qText(
            "thread",
            "Thread size",
            "Example: 1/2-20 or 9/16-18"
          ),

          qSelect(
            "seat",
            "Lug-seat style",
            [
              "60-degree cone",
              "Flat / mag seat",
              "Ball seat",
              "Flanged",
              "Other / unknown"
            ]
          ),

          qText(
            "dimensions",
            "Stud or nut dimensions",
            "Enter knurl, shoulder, usable length, and hex size",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "hub-cap",
        "Hub cap, center cap, dust cap or wheel cover",
        COLLECTIONS.wheels,
        "trailer hub cap center cap dust cap",
        "Confirm whether the cap fits the wheel or hub, pilot or bore diameter, depth, bolt pattern, grease access, material, and retention style.",
        [
          qSelect(
            "component",
            "Cap type",
            [
              "Wheel center cap",
              "Hub dust cap",
              "Grease cap",
              "Oil cap",
              "Decorative wheel cover",
              "Other / unknown"
            ]
          ),

          qText(
            "diameter",
            "Mounting diameter",
            "Enter hub bore, wheel pilot, or cap OD"
          ),

          qText(
            "depth",
            "Required depth",
            "Enter internal or overall depth",
            "",
            {
              required: false
            }
          ),

          shared.boltPattern
        ]
      )
    ],

    rv: [
      task(
        "service-hatch",
        "Electrical, water, sewer or utility hatch",
        COLLECTIONS.hatches,
        "RV trailer utility service hatch",
        "Confirm service type, rough opening, flange dimensions, orientation, lock or latch, connection size, color, wall thickness, and sealing.",
        [
          qSelect(
            "service",
            "Hatch type",
            [
              "Electrical cord hatch",
              "Fresh-water fill hatch",
              "City-water hatch",
              "Sewer hose hatch",
              "Exterior shower hatch",
              "General utility hatch",
              "Other / unknown"
            ]
          ),

          qText(
            "opening",
            "Rough opening",
            "Enter width and height"
          ),

          qText(
            "flange",
            "Exterior flange size",
            "Enter width and height",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "color",
            "Color",
            [
              "White",
              "Black",
              "Polar white",
              "Other / unknown"
            ]
          )
        ],
        {
          trailerPriority: [
            "rv",
            "horse",
            "enclosed"
          ]
        }
      ),

      task(
        "fresh-water",
        "Fresh-water tank, fill, vent or fitting",
        COLLECTIONS.freshWater,
        "RV fresh water tank fitting fill",
        "Confirm potable-water rating, tank dimensions, capacity, fitting locations and threads, mounting orientation, venting, drain, fill connection, and support.",
        [
          qSelect(
            "component",
            "Fresh-water component",
            [
              "Fresh-water tank",
              "Gravity fill",
              "City-water inlet",
              "Tank vent",
              "Drain valve",
              "Tank fitting",
              "Pump-related fitting",
              "Other / unknown"
            ]
          ),

          qText(
            "dimensions",
            "Tank or fitting dimensions",
            "Enter tank size or fitting thread"
          ),

          qText(
            "capacity",
            "Tank capacity",
            "Enter gallons",
            "",
            {
              required: false
            }
          )
        ],
        {
          trailerPriority: [
            "rv",
            "horse"
          ]
        }
      ),

      task(
        "converter-charger",
        "Converter, charger or power-center component",
        COLLECTIONS.converters,
        "RV converter charger power center",
        "Confirm input voltage and frequency, DC output voltage and amperage, battery chemistry, circuits, dimensions, cooling, wiring, and manufacturer model.",
        [
          qSelect(
            "component",
            "Electrical component",
            [
              "Complete converter / charger",
              "Replacement converter section",
              "Power center",
              "Battery charger",
              "Distribution fuse board",
              "Other / unknown"
            ]
          ),

          qText(
            "model",
            "Existing manufacturer and model",
            "Enter all labels and electrical ratings"
          ),

          qText(
            "output",
            "DC output rating",
            "Example: 12 VDC, 45 amps",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "battery",
            "Battery type",
            [
              "Flooded lead acid",
              "AGM",
              "Gel",
              "Lithium",
              "Multiple chemistries",
              "Not sure"
            ]
          )
        ],
        {
          trailerPriority: [
            "rv"
          ]
        }
      ),

      task(
        "rv-vent",
        "RV roof, plumbing or appliance vent",
        COLLECTIONS.vents,
        "RV roof plumbing appliance vent",
        "Confirm vent function, opening, roof thickness, flange, lid and hinge style, power, appliance model, and sealing method.",
        [
          qSelect(
            "vent_type",
            "Vent function",
            [
              "Roof vent",
              "Powered roof vent",
              "Plumbing vent",
              "Refrigerator vent",
              "Furnace vent",
              "Range hood vent",
              "Other / unknown"
            ]
          ),

          qText(
            "opening",
            "Opening dimensions",
            "Enter rough opening width and height"
          ),

          qText(
            "model",
            "Appliance or vent model",
            "Enter manufacturer and model",
            "",
            {
              required: false
            }
          )
        ],
        {
          trailerPriority: [
            "rv"
          ]
        }
      )
    ],

    maintenance: [
      task(
        "grease-lubricant",
        "Grease, oil or lubricant",
        COLLECTIONS.grease,
        "trailer bearing grease oil lubricant",
        "Confirm manufacturer requirements, grease base and thickener compatibility, NLGI grade, temperature, water exposure, oil viscosity, and whether lubricants can be mixed.",
        [
          qSelect(
            "application",
            "Lubricant application",
            [
              "Wheel bearings",
              "Oil-bath hubs",
              "Suspension wet bolts",
              "Jack or landing gear",
              "Door and hinge hardware",
              "General chassis",
              "Other / unknown"
            ]
          ),

          qText(
            "existing",
            "Existing lubricant or specification",
            "Enter product, viscosity, or grease type",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "environment",
            "Operating environment",
            [
              "General road use",
              "Marine / water exposure",
              "High temperature",
              "Cold temperature",
              "Heavy commercial use",
              "Other / unknown"
            ]
          )
        ]
      ),

      task(
        "specialty-fastener",
        "Specialty screw, bolt, nut or trailer fastener",
        COLLECTIONS.specialtyScrews,
        "trailer specialty screw bolt fastener",
        "Confirm fastener type, diameter, thread, length, head, drive, material, grade, finish, load requirement, and installation substrate.",
        [
          qSelect(
            "component",
            "Fastener type",
            [
              "Self-drilling screw",
              "Floor screw",
              "Machine bolt",
              "Carriage bolt",
              "Flange bolt",
              "Lock nut",
              "Rivet",
              "Other / unknown"
            ]
          ),

          qText(
            "size",
            "Fastener size",
            "Enter diameter, thread, and length"
          ),

          qSelect(
            "material",
            "Material or finish",
            [
              "Zinc plated",
              "Galvanized",
              "Stainless steel",
              "Black oxide",
              "Grade-marked steel",
              "Other / unknown"
            ]
          ),

          qText(
            "application",
            "Installation application",
            "Example: wood deck to steel crossmember",
            "",
            {
              required: false
            }
          )
        ]
      ),

      task(
        "document-holder",
        "Registration or document holder",
        COLLECTIONS.documentHolders,
        "trailer registration document holder",
        "Confirm document size, tube or pouch dimensions, weather resistance, mounting method, cap or lock style, and installation location.",
        [
          qSelect(
            "style",
            "Holder style",
            [
              "Round document tube",
              "Rectangular document box",
              "Registration pouch",
              "Lockable document holder",
              "Other / unknown"
            ]
          ),

          qText(
            "dimensions",
            "Required internal dimensions",
            "Enter document size or mounting space",
            "",
            {
              required: false
            }
          ),

          qSelect(
            "mounting",
            "Mounting method",
            [
              "Bolt-on",
              "Screw-on",
              "Adhesive",
              "Clamp-on",
              "Other / unknown"
            ]
          )
        ]
      ),

      task(
        "wire-loom",
        "Wire loom, conduit, clamp or electrical protection",
        COLLECTIONS.wireLoom,
        "trailer wire loom conduit clamp",
        "Confirm wire-bundle diameter, loom ID, split or non-split construction, temperature, abrasion and chemical exposure, clamp spacing, and length.",
        [
          qSelect(
            "component",
            "Protection component",
            [
              "Split wire loom",
              "Non-split loom",
              "Braided sleeve",
              "Rubber grommet",
              "Cable clamp",
              "Conduit",
              "Other / unknown"
            ]
          ),

          qText(
            "diameter",
            "Required inside diameter",
            "Enter wire-bundle or opening diameter"
          ),

          qText(
            "length",
            "Required length",
            "Enter feet or inches",
            "",
            {
              required: false
            }
          )
        ]
      )
    ],

    unknown: [
      task(
        "search-part-number",
        "Search by SKU, manufacturer number, bearing, seal or casting",
        null,
        "trailer part number",
        "Enter the number exactly as shown. Search results may include visually similar parts that are not compatible.",
        [
          shared.partNumber,

          qText(
            "context",
            "Where is the part used?",
            "Example: hub, brake, coupler, jack, light, or door",
            "",
            {
              required: false
            }
          )
        ],
        {
          resultType: "search"
        }
      ),

      task(
        "describe-problem",
        "Describe the repair or problem",
        null,
        "trailer repair part",
        "A symptom does not automatically identify the failed component. Treat results as a starting point and confirm fitment.",
        [
          qText(
            "problem",
            "Describe what is happening",
            "Example: wheel is loose, lights flicker, ramp is heavy, or coupler will not latch"
          ),

          qText(
            "known_details",
            "Known numbers or measurements",
            "Enter labels, dimensions, or stamped numbers",
            "",
            {
              required: false
            }
          )
        ],
        {
          resultType: "fitment_help"
        }
      ),

      task(
        "photo-help",
        "I have photos or measurements and need help",
        null,
        "",
        "Photos and measurements can support identification but may not prove capacity, internal construction, or compatibility.",
        [
          qSelect(
            "evidence",
            "Information available",
            [
              "Photos only",
              "Measurements only",
              "Photos and measurements",
              "Existing part number",
              "Trailer VIN or axle tag",
              "Other"
            ]
          ),

          qText(
            "summary",
            "Brief description",
            "Describe the part, location, and repair goal"
          )
        ],
        {
          resultType: "fitment_help"
        }
      )
    ]
  };

  const trailerAreaPriority = {
    utility: [
      "axles",
      "suspension",
      "brakes",
      "lighting",
      "towing",
      "jacks",
      "wheels",
      "doors",
      "cargo",
      "maintenance",
      "unknown"
    ],

    enclosed: [
      "doors",
      "lighting",
      "axles",
      "suspension",
      "brakes",
      "cargo",
      "towing",
      "jacks",
      "wheels",
      "maintenance",
      "rv",
      "unknown"
    ],

    equipment: [
      "axles",
      "brakes",
      "suspension",
      "towing",
      "jacks",
      "wheels",
      "cargo",
      "lighting",
      "doors",
      "maintenance",
      "unknown"
    ],

    boat: [
      "axles",
      "brakes",
      "wheels",
      "towing",
      "jacks",
      "lighting",
      "cargo",
      "maintenance",
      "unknown"
    ],

    horse: [
      "axles",
      "suspension",
      "brakes",
      "doors",
      "lighting",
      "towing",
      "jacks",
      "wheels",
      "rv",
      "cargo",
      "maintenance",
      "unknown"
    ],

    rv: [
      "rv",
      "lighting",
      "towing",
      "axles",
      "suspension",
      "brakes",
      "jacks",
      "wheels",
      "doors",
      "maintenance",
      "unknown"
    ],

    dump: [
      "axles",
      "suspension",
      "brakes",
      "towing",
      "jacks",
      "wheels",
      "lighting",
      "doors",
      "maintenance",
      "unknown"
    ],

    flatbed: [
      "axles",
      "suspension",
      "brakes",
      "towing",
      "jacks",
      "wheels",
      "cargo",
      "lighting",
      "maintenance",
      "unknown"
    ],

    "tow-vehicle": [
      "towing",
      "brakes",
      "lighting",
      "cargo",
      "maintenance",
      "unknown"
    ],

    unknown: [
      "unknown",
      "axles",
      "brakes",
      "suspension",
      "towing",
      "lighting",
      "jacks",
      "wheels",
      "doors",
      "cargo",
      "rv",
      "maintenance"
    ]
  };

  const methodQuestions = {
    number: [
      shared.partNumber,

      qText(
        "number_context",
        "Part type or location",
        "Example: bearing, brake, coupler, jack, light, door, or wheel",
        "",
        {
          required: false
        }
      )
    ],

    spec: [
      qText(
        "specification",
        "Enter verified specifications or measurements",
        "Include dimensions, capacity, bolt pattern, thread, or electrical details",
        "State units and measurement points."
      ),

      qText(
        "spec_context",
        "What component are you measuring?",
        "Example: axle, hub, spring, coupler, jack, light, or wheel",
        "",
        {
          required: false
        }
      )
    ],

    problem: [
      qText(
        "problem",
        "Describe the repair or symptom",
        "Explain what is damaged, missing, worn, leaking, loose, or not operating"
      ),

      qText(
        "problem_context",
        "Known trailer and part details",
        "Enter trailer type, axle tag, manufacturer, number, or measurements",
        "",
        {
          required: false
        }
      )
    ],

    help: [
      qSelect(
        "help_evidence",
        "What information do you have?",
        [
          "Photos",
          "Measurements",
          "Photos and measurements",
          "Part number",
          "Axle tag or trailer label",
          "Very little information"
        ]
      ),

      qText(
        "help_summary",
        "Describe the part and repair goal",
        "Tell us where it is located and what you are trying to repair"
      )
    ]
  };

  window.RPPartsFinderData = {
    version: "1.1.0",
    camberNote: CAMBER_NOTE,
    collections: COLLECTIONS,
    options: OPTIONS,
    trailerTypes,
    areas,
    methods,
    tasks,
    trailerAreaPriority,
    methodQuestions
  };
})();